import { useMemo } from "react";
import { createTranslatorWithInterpolation, } from "./translators/createTranslatorWithInterpolation";
import { useTranslatorOptions } from "./useTranslatorOptions";
/**
 * Provides a translator function that uses interpolations
 *
 * Notes
 * - uses the configuration language
 *
 * @category Translation
 * @returns
 */
export function useTranslatorWithInterpolation() {
    const options = useTranslatorOptions();
    return useMemo(() => {
        return createTranslatorWithInterpolation(options);
    }, [options]);
}
//# sourceMappingURL=useTranslatorWithInterpolation.js.map